var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57171 1.4654H12.4289C12.5074 1.4654 12.5717 1.40112 12.5717 1.32254V0.322545C12.5717 0.243973 12.5074 0.179688 12.4289 0.179688H3.57171C3.49314 0.179688 3.42885 0.243973 3.42885 0.322545V1.32254C3.42885 1.40112 3.49314 1.4654 3.57171 1.4654ZM12.4289 9.03683C12.5074 9.03683 12.5717 8.97255 12.5717 8.89397V7.89397C12.5717 7.8154 12.5074 7.75112 12.4289 7.75112H3.57171C3.49314 7.75112 3.42885 7.8154 3.42885 7.89397V8.89397C3.42885 8.97255 3.49314 9.03683 3.57171 9.03683H12.4289ZM15.0003 11.5368H1.00028C0.921708 11.5368 0.857422 11.6011 0.857422 11.6797V12.6797C0.857422 12.7583 0.921708 12.8225 1.00028 12.8225H15.0003C15.0789 12.8225 15.1431 12.7583 15.1431 12.6797V11.6797C15.1431 11.6011 15.0789 11.5368 15.0003 11.5368ZM15.0003 3.9654H1.00028C0.921708 3.9654 0.857422 4.02969 0.857422 4.10826V5.10826C0.857422 5.18683 0.921708 5.25112 1.00028 5.25112H15.0003C15.0789 5.25112 15.1431 5.18683 15.1431 5.10826V4.10826C15.1431 4.02969 15.0789 3.9654 15.0003 3.9654Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenter);
export default __webpack_public_path__ + "static/media/align-center.3c499715de49817ec0852ff3b4a6cc5e.svg";
export { ForwardRef as ReactComponent };